import priorityColors, {
  getColorStyleForName
} from "assets/jss/default/priorityColors";
import { useTheme } from "@mui/material/styles";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { isNil } from "lodash";

/**
 * A hook which gets the dropdown data for the case statuses
 * @param scalarConfigs
 * @returns {{data: any, loading: boolean, error: boolean}}
 */
export function useCaseStatusEnums(scalarConfigs) {
  const theme = useTheme();
  const scalar_configs = scalarConfigs?.join(",");

  const {
    loading: caseStatusTypesLoading,
    response: caseStatusTypesData,
    error: caseStatusTypesError
  } = useFetchGetV2("case_status_types");

  const {
    loading: componentsLoading,
    response: componentsData,
    error: componentsError
  } = useFetchGetV2(
    `components?scalar_configuration_id__in=${scalar_configs}`,
    isNil(scalar_configs)
  );

  const {
    loading: casePriorityTypesLoading,
    response: casePriorityTypesData,
    error: casePriorityTypesError
  } = useFetchGetV2("case_priority_types?ordering=-order");

  const loading =
    caseStatusTypesLoading || casePriorityTypesLoading || componentsLoading;
  const error =
    caseStatusTypesError || casePriorityTypesError || componentsError;

  // the creative tim component likes dropdown values to be in the format
  // [
  //   { id, name, color },
  //   ...
  // ]
  const casePriorityTypeValues = casePriorityTypesData?.results.map(x => {
    return {
      ...x,
      color: priorityColors(theme)[getColorStyleForName(x.name)]
        ?.backgroundColor[0],
      colorObject: priorityColors(theme)[getColorStyleForName(x.name)]
    };
  });

  return {
    data: {
      casePriorityTypeValues,
      caseStatusTypeValues: caseStatusTypesData?.results,
      componentValues: componentsData?.results
    },
    loading,
    error
  };
}
